import {
  animate,
  state,
  style,
  transition,
  trigger,
  type AnimationTriggerMetadata,
} from '@angular/animations';

export const stretch: AnimationTriggerMetadata = trigger('stretch', [
  state(
    'short',
    style({
      width: '{{ short }}',
    }),
    { params: { short: '200px' } },
  ),
  state(
    'long',
    style({
      width: '{{ long }}',
    }),
    { params: { long: '500px' } },
  ),
  transition('short => long', [animate('300ms ease-in-out')]),
  transition('long => short', [animate('300ms ease-in-out')]),
]);
